<template>
  <div id="app" class="app">
    <header class="app-header">
      <img :src="telenorLogo" alt="Telenor" class="app-logo" />
    </header>

    <router-view v-slot="{ Component }">
      <keep-alive include="SignUp">
        <component :is="Component" :key="route.fullPath" />
      </keep-alive>
    </router-view>
  </div>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router';

import telenorLogo from '@/assets/telenor-logo-flat-blue.svg';

const route = useRoute();
</script>

<style scoped>
.app {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  background-color: #fff;
}

.app-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 96px;
  border-bottom: 1px solid #f5f5f5;
}

.app-logo {
  width: 184px;
  height: 48px;
}
</style>
